import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Avatar, Input, Row, Col, Button, Select } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import { CONTRACTORS } from '../../graphql/queries/queries';
import _s from './index.less';
import _ from 'lodash';
import { RedoOutlined } from '@ant-design/icons';

const { Option } = Select;

const SIZES_RANGE = {
  '0 - 200': {
    gte: 0,
    lte: 200
  },
  '200 - 300': {
    gte: 200,
    lte: 300
  },
  '300 - 400': {
    gte: 300,
    lte: 400
  },
  '400 - 500': {
    gte: 400,
    lte: 500
  },
  '500 - 600': {
    gte: 500,
    lte: 600
  },
  '600 - 700': {
    gte: 600,
    lte: 700
  },
  '700 - 800': {
    gte: 700,
    lte: 800
  },
  '800 - 900': {
    gte: 800,
    lte: 900
  },
  '900 - 1000': {
    gte: 900,
    lte: 1000
  },
  '1000 - 1100': {
    gte: 1000,
    lte: 1100
  },
  '1100 - 1200': {
    gte: 1100,
    lte: 1200
  },
  '1200+': {
    gte: 1200
  }
};

const Filters = props => {
  const { filters, setFilters, role, setUnlocked = null } = props;

  const { data, refetch } = useQuery(CONTRACTORS);
  const contractors = (data && data[Object.keys(data)[0]]) || [];

  const handleChange = (value, field) => {
    if (setUnlocked) setUnlocked(false);
    if (typeof value === 'object') {
      if (!filters[field]) filters[field] = {};
      setFilters({ ...filters, [field]: { ...filters[field], ...value } });
      return;
    }
    setFilters({ ...filters, [field]: value });
  };

  const handleChangeSize = (e, sizeField, valueField) => {
    if (setUnlocked) setUnlocked(false);
    const newState = { ...filters };
    if (!newState.meta) newState.meta = {};
    if (!newState.meta[sizeField]) {
      newState.meta = {
        ...newState.meta,
        [sizeField]: {
          [valueField]: +e.target.value
        }
      };
      setFilters(newState);
      return;
    }

    newState.meta[sizeField] = {
      ...newState.meta[sizeField],
      [valueField]: +e.target.value
    };
    setFilters(newState);
  };

  useEffect(() => {
    refetch();
    setFilters({ ...filters, contractorId: '' });
  }, [data]);

  const onDropFilter = () => {
    setFilters({ contractorId: '' });
    refetch();
  };

  const getValueArea = () => {
    if (!filters.meta || !filters.meta.outerArea) return null;
    const key = `${filters.meta.outerArea.gte}${
      filters.meta.outerArea.lte ? ' - ' + filters.meta.outerArea.lte : '+'
    }`;

    return key;
  };

  return (
    <div style={{ display: 'block' }}>
      <Row gutter={[16, 16]}>
        {role === 'ADMIN' ? (
          <Col span={24} lg={5}>
            <Select
              placeholder="Contractor"
              value={filters.contractorId}
              style={{ width: '100%' }}
              onChange={value => handleChange(value, 'contractorId')}
            >
              <Option key="any" value="">
                Any contractor
              </Option>
              {_.map(contractors, c => (
                <Option key={c.id} value={c.id}>
                  <Avatar style={{ marginRight: 5 }} src={c.logo} />
                  {c.name}
                </Option>
              ))}
            </Select>
          </Col>
        ) : null}
        {role === 'ADMIN' ? (
          <Col span={24} lg={3}>
            <Select
              placeholder="Type"
              value={filters.meta && filters.meta.type}
              style={{ width: '100%' }}
              onChange={value => handleChange({ type: value }, 'meta')}
            >
              <Option key="all" value="">
                All
              </Option>
              <Option key="house" value="house">
                House
              </Option>
              <Option key="shed" value="shed">
                Shed
              </Option>
            </Select>
          </Col>
        ) : null}
        <Col span={24} lg={role === 'ADMIN' ? 4 : 8}>
          <Select
            placeholder="Sq Ft"
            value={getValueArea()}
            style={{ width: '100%' }}
            onChange={value => handleChange({ outerArea: SIZES_RANGE[value] }, 'meta')}
          >
            <Option key="all" value="">
              All
            </Option>
            {_.map(SIZES_RANGE, (item, key) => (
              <Option key={key} value={item[key]}>
                {key}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={24} lg={role === 'ADMIN' ? 6 : 8}>
          <Select
            placeholder="Bedrooms"
            value={filters.meta && filters.meta.bedroomCount}
            style={{ width: '100%' }}
            onChange={value => handleChange({ bedroomCount: value }, 'meta')}
          >
            <Option key="0" value={0}>
              Studio
            </Option>
            <Option key="1" value={1}>
              1
            </Option>
            <Option key="2" value={2}>
              2
            </Option>
            <Option key="3" value={3}>
              3
            </Option>
            <Option key="4" value={4}>
              4
            </Option>
          </Select>
        </Col>
        <Col span={24} lg={role === 'ADMIN' ? 6 : 8}>
          <Select
            placeholder="Bathrooms"
            value={filters.meta && filters.meta.bathroomCount}
            style={{ width: '100%' }}
            onChange={value => handleChange({ bathroomCount: value }, 'meta')}
          >
            <Option key="bathroomCount-0" value={0}>
              0
            </Option>
            <Option key="bathroomCount-1" value={1}>
              1
            </Option>
            <Option key="bathroomCount-2" value={2}>
              2
            </Option>
          </Select>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={24} lg={2}>
          <span className={_s.filterLabel}>Width, ft</span>
        </Col>
        <Col span={24} lg={3}>
          <Input
            addonBefore="from"
            type="number"
            min={0}
            // size='small'
            value={filters.meta && filters.meta.width && filters.meta.width.gte}
            placeholder="0"
            onChange={e => handleChangeSize(e, 'width', 'gte')}
          />
        </Col>
        <Col span={24} lg={3}>
          <Input
            addonBefore="to"
            type="number"
            min={0}
            // size='small'
            value={filters.meta && filters.meta.width && filters.meta.width.lte}
            placeholder="100"
            onChange={e => handleChangeSize(e, 'width', 'lte')}
          />
        </Col>
        <Col span={24} lg={2}>
          <span className={_s.filterLabel}>Length, ft</span>
        </Col>
        <Col span={24} lg={3}>
          <Input
            addonBefore="from"
            type="number"
            min={0}
            // size='small'
            value={filters.meta && filters.meta.length && filters.meta.length.gte}
            placeholder="0"
            onChange={e => handleChangeSize(e, 'length', 'gte')}
          />
        </Col>
        <Col span={24} lg={3}>
          <Input
            addonBefore="to"
            type="number"
            // size='small'
            min={0}
            value={filters.meta && filters.meta.length && filters.meta.length.lte}
            placeholder="100"
            onChange={e => handleChangeSize(e, 'length', 'lte')}
          />
        </Col>
        {role === 'ADMIN' ? (
          <Col span={24} lg={6}>
            <span className={_s.metaPlanList} style={{ display: 'inline-block' }}>
              Hidden
            </span>
            <Switch
              checked={filters.isHidden}
              onChange={() => handleChange(!filters.isHidden, 'isHidden')}
            />
          </Col>
        ) : (
          <Col span={24} lg={6}></Col>
        )}
        <Col span={24} lg={2}>
          <Button style={{ width: '100%' }} type="dashed" onClick={onDropFilter}>
            <RedoOutlined />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

Filters.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func,
  role: PropTypes.string,
  setUnlocked: PropTypes.func
};

export default Filters;
